<script lang="ts">
    export let label: string;
    export let italicizeLabel = false;
    export let marginRight = false;
</script>

<style>
    .faux_input {
        color: #eee;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-bottom: 0.5rem;
    }

    .label {
        font: 400 1.1rem/1.75 IBM Plex Mono, Monaco, monospace;
        margin-right: 0.25rem;
    }

    .italicizeLabel {
        font-style: italic;
        margin-right: 0.5rem;
    }

    .marginRight {
        margin-right: 1.5rem;
    }

    .value {
        font: 400 1.25rem/1 Crimson Text, Georgia, serif;
        border-bottom: 1px solid #aaa;
        background: #343434;
        padding: 0.15rem 1rem 0.2rem 0.25rem;
    }
</style>

<div class="faux_input" class:marginRight>
    <div class="label" class:italicizeLabel>{label}</div>
    <div class="value"><slot /></div>
</div>